import * as React from 'react'
import { ActionIcon } from '@mantine/core'

// 社区行政村减灾能力
const SvgComponent = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    className="design-iconfont"
    width={width}
    height={height}
  >
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="k8di5td0u__5d4opviqab"
      >
        <stop stopColor="#F9945B" offset="0%" />
        <stop stopColor="#F97241" offset="47.1229006%" />
        <stop stopColor="#F94B23" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="k8di5td0u__q9m6i3yj4a"
      >
        <stop stopColor="#FFB083" offset="0%" />
        <stop stopColor="#FF7A5C" offset="100%" />
      </linearGradient>
      <filter
        x="-111.5%"
        y="-111.5%"
        width="323.1%"
        height="323.1%"
        filterUnits="objectBoundingBox"
        id="k8di5td0u__iieepxx9lc"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.976470588 0 0 0 0 0.321568627 0 0 0 0 0.156862745 0 0 0 1 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        d="M10.7586207,1 C13.4527454,1 15.8915589,2.09863836 17.6570109,3.87410315 C19.424504,5.65162062 20.5172414,8.10737032 20.5172414,10.8196383 C20.5172414,13.2054308 19.0111003,16.1209359 17.1884092,18.6927443 C14.8576982,21.9813662 11.9231088,25 10.7586207,25 C9.59413261,25 6.6595432,21.9813662 4.3288322,18.6927443 C2.50614105,16.1209359 1,13.2054308 1,10.8196383 C1,8.10737032 2.0927374,5.65162062 3.8602305,3.87410315 C5.62568251,2.09863836 8.06449597,1 10.7586207,1 Z"
        stroke="url(#k8di5td0u__q9m6i3yj4a)"
        strokeWidth="2"
        fill="url(#k8di5td0u__5d4opviqab)"
        transform="translate(4 4)"
      />
      <g
        filter="url(#k8di5td0u__iieepxx9lc)"
        transform="translate(9.37931 9.37931)"
        fill="#FFE9E1"
        fillRule="nonzero"
      >
        <path d="M7.46110345,6.87356088 L5.67815625,8.44911045 L5.67815625,10.7586207 L9.86207247,10.7586207 L9.86207247,10.7263448 C9.85669316,9.10208728 8.93234483,7.60754256 7.46110345,6.87356088 L7.46110345,6.87356088 Z M8.36572064,9.30980011 C8.35018157,9.44248626 8.28204714,9.5384208 8.18820339,9.5605264 L6.51792753,9.5605264 C6.40317592,9.58264251 6.2937931,9.47206196 6.27795986,9.3097896 C6.26211611,9.14781142 6.34071498,8.99301967 6.45546659,8.97089305 C6.4757333,8.96348833 6.49796552,8.96348833 6.51823222,8.97089305 L8.18820339,8.97089305 C8.3032597,8.99300916 8.38156439,9.14782193 8.36572064,9.3097896 L8.36572064,9.30980011 Z M5.08046444,10.7529472 L5.08046444,8.26919774 L3.2927368,6.57471498 C1.82329203,7.36965517 0.896548222,8.97149192 0.896548222,10.7236552 L0.896548222,10.7586207 L5.08046444,10.7586207 L5.08046444,10.7526425 L5.08046444,10.7529472 Z M2.39290005,9.0925264 C2.4087333,9.02528502 2.47777128,8.97657705 2.57310695,8.96551374 L4.28133217,8.96551374 C4.39788039,8.96940113 4.48276212,9.03634833 4.48276212,9.1149472 C4.48276212,9.19712877 4.38712177,9.26437015 4.26519423,9.26437015 L2.57310695,9.26437015 C2.45654822,9.25330684 2.3770563,9.17859537 2.39290005,9.0925264 L2.39290005,9.0925264 Z M7.4712632,2.39080927 C7.31287823,1.3185194 6.48087123,0.502671336 5.4564278,0.407335668 L5.4564278,0.204707974 C5.44905014,0.143162023 5.41734062,0.0871310934 5.36837623,0.0491202759 C5.31941184,0.0111094584 5.2572683,-0.00571728381 5.19581492,0.00239547414 C5.0942069,0.0203195043 5.02038847,0.0977206358 5.00335749,0.204707974 L5.00335749,0.401357489 C3.97889305,0.496693157 3.14689655,1.31882408 2.98850108,2.38483109 C3.72094353,2.18790256 4.47718853,2.09365923 5.23556088,2.10480226 C5.98268615,2.09882408 6.73549542,2.19446444 7.4712632,2.39080927 L7.4712632,2.39080927 Z M5.17577909,1.49156088 C4.97086547,1.46576431 4.80961678,1.30414779 4.78428718,1.09917592 C4.75714446,0.85403468 4.93120819,0.63226715 5.17577909,0.600391972 C5.4207742,0.57381698 5.64193194,0.748320024 5.67307112,0.99277694 C5.67970512,1.02793304 5.67970512,1.06401981 5.67307112,1.09917592 C5.6400082,1.34253949 5.4201583,1.51601059 5.17577909,1.49156088 L5.17577909,1.49156088 Z M6.6688424,6.27585857 C6.321318,6.4174504 5.9502801,6.49247272 5.5750458,6.49701967 L5.47642161,6.49701967 C5.10113032,6.49304328 4.72999021,6.41799958 4.38263551,6.27585857 C4.21497333,6.31770582 4.04702748,6.36552074 3.8850493,6.41781142 L5.52872279,7.77011961 L7.17240679,6.41781142 C7.00573464,6.36638592 6.83782581,6.31905756 6.6688319,6.27585857 L6.6688424,6.27585857 Z M2.62630119,4.61903098 C2.58880541,4.43977412 2.57027505,4.25706948 2.57101616,4.07393454 L2.57101616,3.55632301 C2.71446094,3.51268966 2.86328502,3.47443561 3.01241379,3.44186557 L3.01241379,4.11217807 C3.0177931,5.30579661 3.99413793,6.27047926 5.20238147,6.27585857 L5.25738281,6.27585857 C6.46562635,6.27585857 7.44765517,5.30579661 7.44765517,4.11218858 L7.44765517,3.4690563 C7.59647926,3.50193103 7.74530334,3.53988039 7.88875862,3.58351374 L7.88875862,4.10112527 C7.88875862,4.2864173 7.86664251,4.46633001 7.83376778,4.64623222 C8.35765167,4.43374946 8.66666783,4.15581142 8.66666783,3.85607247 C8.66666783,3.40899084 7.98259186,3.02227936 6.96769881,2.82593454 C6.80751724,2.7876805 6.63119774,2.76615275 6.44352074,2.73866783 L6.39390921,2.73866783 C6.22296902,2.73866783 6.04634483,2.69503448 5.86972064,2.68965517 L4.59034833,2.68965517 C4.40805065,2.68965517 4.23172064,2.7225299 4.06615975,2.73866783 L4.01654822,2.73866783 C3.84022872,2.73866783 3.66899434,2.7876805 3.49266433,2.82593454 C2.47717241,3.0384173 1.79304013,3.42543346 1.79304013,3.85607247 C1.78772764,4.12862069 2.10749192,4.40654822 2.62630119,4.61903098 L2.62630119,4.61903098 Z" />
      </g>
    </g>
  </svg>
)

const Icon = (props) => {
  const {
    fill = '#0152D9',
    variant = 'transparent',
    size = 20,
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <SvgComponent width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default Icon
